import React from "react";

const Salesection = () => {
  const options = [
    { mainheading: "Properties for rent in Pakistan", label: "All properties" },
    { mainheading: "Shops for rent in Pakistan", label: "All Shops" },
    {
      mainheading: "Apartments for sale in Gulberg, Lahore",
      label: "All properties",
    },
  ];
  return (
    <div className="flex flex-col md:flex-row w-full gap-4 justify-center items-start px-4">
      {options.map((item, index) => {
        return (
          <div className="p-4 border shadow-md h-full shadow-[#d5d5d5] rounded-lg md:max-w-[400px] w-full flex-wrap">
            <p className="text-[16px] font-semibold ">{item.mainheading}</p>
            <div className="flex justify-between w-full items-center">
              <p className="text-[14px] font-light">{item.label}</p>
              <div className="p-2 hover:bg-[#2a9933] cursor-pointer rounded-lg fill-currentColor hover:fill-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  //   fill="currentColor"
                  aria-hidden="true"
                  className="ml-1 -mr-1 h-4 w-4 tranform -rotate-90 "
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Salesection;
